module.exports = __webpack_public_path__ + "media/entities/1015-097bfe8c.png";